import React, { useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import RecentlyOpened from "./RecentlyOpened";
import SharedFiles from "./SharedFiles";

enum FlowOption {
  RecentlyOpened = "Recently Opened",
  SharedFiles = "Shared Files",
}

const FlowsSection: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<FlowOption>(
    FlowOption.RecentlyOpened,
  );
  const theme = useTheme();
  const { semanticColors } = theme;

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        padding: "20px",
        width: "100%",
        backgroundColor: semanticColors.backgroundSecondary,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginBottom: "20px",
          flexShrink: 0,
        }}
      >
        <Box>
          <Box
            sx={{
              background:
                selectedOption === FlowOption.RecentlyOpened
                  ? semanticColors.tabActive
                  : semanticColors.tabInactive,
              display: "inline-block",
              padding: "8px 10px",
              borderRadius: "8px",
              cursor: "pointer",
              marginRight: "10px",
            }}
            onClick={() => {
              setSelectedOption(FlowOption.RecentlyOpened);
            }}
          >
            <Typography
              sx={{
                color:
                  selectedOption === FlowOption.RecentlyOpened
                    ? semanticColors.tabTextActive
                    : semanticColors.tabTextInactive,
                fontWeight:
                  selectedOption === FlowOption.RecentlyOpened ? 700 : 400,
                fontSize: "12px",
                lineHeight: "20px",
                letterSpacing: "0.4px",
              }}
            >
              {FlowOption.RecentlyOpened}
            </Typography>
          </Box>
          <Box
            sx={{
              background:
                selectedOption === FlowOption.SharedFiles
                  ? semanticColors.tabActive
                  : semanticColors.tabInactive,
              display: "inline-block",
              padding: "8px 10px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
            onClick={() => {
              setSelectedOption(FlowOption.SharedFiles);
            }}
          >
            <Typography
              sx={{
                color:
                  selectedOption === FlowOption.SharedFiles
                    ? semanticColors.tabTextActive
                    : semanticColors.tabTextInactive,
                fontWeight:
                  selectedOption === FlowOption.SharedFiles ? 700 : 400,
                fontSize: "12px",
                lineHeight: "20px",
                letterSpacing: "0.4px",
              }}
            >
              {FlowOption.SharedFiles}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          maxHeight: "calc(100% - 100px)",
        }}
      >
        {selectedOption === FlowOption.RecentlyOpened && <RecentlyOpened />}
        {selectedOption === FlowOption.SharedFiles && <SharedFiles />}
      </Box>
    </Box>
  );
};

export default FlowsSection;
